import {Fragment} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

type Props = {
    removeRow: () => void;
};

export default ({removeRow}: Props) => {
    return (
        <Fragment>
            <IconButton color="secondary" size="small" onClick={removeRow}>
                <FontAwesomeIcon icon="trash" />
            </IconButton>
        </Fragment>
    );
};
